
























































import { Prop, Component, Watch } from "vue-property-decorator";
import { Site } from "@/shared/Site";
import { MyOptions } from "@/charts/graphData";
import { mixins } from "vue-class-component";
import chartsMixin from "./chartsMixin";
import jsonURL from "@/shared/urls";
import moment from "moment/moment";
import NumberTmpl from "@/ui-component/number.vue";

@Component({
  components: {
    NumberTmpl,
  },
})
export default class TauxCat extends mixins(chartsMixin) {
  public dataGetted = false;
  public data = { tauxCa: 0, caCat: 0, nbTables: 0, tauxTable: 0 };
  public config: any;
  public titre = "";
  public date = "";
  @Prop() public myOptions!: MyOptions;
  @Prop() public periode!: string;

  @Watch("myOptions", { immediate: true, deep: true })
  public onPeriodeChanged(value: any, oldValue: any) {
    this.init();
  }

  public mounted() {
    this.init();
  }

  public init() {
    this.config = {
      site: this.myOptions.site[0],
      periode: this.periode,
      service: "GLOBAL",
      WS: jsonURL.getTauxCatPeriode,
      date: moment(this.myOptions.date).format("YYYY-MM-DD"),
    };
    this.titre = this.$t("CAT").toString();
    this.date = moment(this.myOptions.date).format("DD MMMM yyyy");
    this.getData();
  }

  /**
   *
   */
  private getData() {
    this.$store
      .dispatch("home/getServiceHomeData", {
        config: this.config,
        WS: this.config.WS,
      })
      .then((dataResponse: any) => {
        // console.log(dataResponse);
        this.data.tauxCa = dataResponse["tauxCACAT"] * 100;
        this.data.caCat = dataResponse["CACAT"];
        this.data.tauxTable = dataResponse["tauxNbTablesCAT"] * 100;
        this.data.nbTables = dataResponse["nbTablesCAT"];
      });
  }

  get sites(): Site[] {
    return this.$store.getters["login/sites"];
  }
}
